import { useLocation } from 'react-router-dom'

const useQuery = (query: string): string | null => new URLSearchParams(useLocation().search).get(query)

export default useQuery
